import type { ItemsList } from '@pages/organizer/Cloud/store/cloud-store/cloud-types';

export const isAlreadySelected = <T extends { id: string }>(selectItem: T, selectedFiles: ItemsList) => {
  return selectedFiles.some((selected) => selected.id === selectItem.id);
};
